export const zip = (v: string): string => {
  const pre = v.slice(0, 3)
  const suf = v.slice(3, v?.length)
  return `${pre}-${suf}`
}
